import { render } from "./App.vue?vue&type=template&id=6ca5b012&bindings={}"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./scss/app.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script